import clsx from 'clsx'
import { RiPlayCircleFill } from '@remixicon/react'
import { ThumbnailImage } from '../ThumbnailImage'
import { VideoOverlay } from './styles'
import { ThumbnailVideoProps } from './types'

const ThumbnailVideo = ({ src, dataTestId, className }: ThumbnailVideoProps) => {
  return (
    <div
      className={clsx(
        '_d-flex _justify-content-center _align-items-center _position-relative',
        className
      )}
    >
      <ThumbnailImage src={src} dataTestId={dataTestId} />

      <VideoOverlay className="_d-flex _justify-content-center _align-items-center _position-absolute _rounded">
        <RiPlayCircleFill size={30} className="_position-absolute play-icon" />
      </VideoOverlay>
    </div>
  )
}

export default ThumbnailVideo
